<template>
  <div id="app" class="pt-14">
    <header-app />
    <router-view class="grid-1 p-4 scroll-smooth light break-words" />
  </div>
</template>

<script>
import headerApp from "@/components/headerApp.vue";
import data from "@/assets/data.json";
import { db } from "@/assets/db.js";

export default {
  components: { headerApp },
  created() {
    if (!localStorage.save) {
      for (let index = 0; index < data.length; index++) {
        const product = data[index];
        db.products.put(product);
        if (index == data.length - 1) {
          localStorage.save = true;
        }
      }
    }
  },
};
</script>
